
import { z } from "zod";

export const contractFormSchema = z.object({
  supplierName: z.string().min(1, "Supplier name is required"),
  organisationnumber: z.string().optional(),
  importance: z.number().min(1).max(5),
  contractTypeId: z.string().min(1, "Contract type is required"),
  expectedCost: z.number().min(0, "Cost must be a positive number"),
  currencyId: z.string().min(1, "Currency is required"),
  paymentFrequencyInterval: z.number().min(1),
  paymentFrequencyUnit: z.enum(["Day", "Month", "Year"]),
  signedDate: z.date(),
  expiryDate: z.date(),
  reminderPeriod: z.string(),
  reminderFrequency: z.string(),
  categoryId: z.string().optional(),
  contactPersonIds: z.array(z.string()).optional(),
  use_services_cost: z.boolean().default(false),
  paymentType: z.enum(["BankTransfer", "Cash", "Cards"]).default("BankTransfer")
});

export type ContractFormValues = z.infer<typeof contractFormSchema>;
